export default class ReferencialDto {
    constructor(object) {
        this.id = object.id
        this.code = object.code
        this.name = object.name
        this.status = object.status
        this.active = object.active
        this.labelWithCode = (object.code ? `${object.name || ''} [${object.code}]` : (object.name || '')) + (object.internalCode ? ` [${object.internalCode}]` : '')
    }
}